import { YOUTUBE_REGEXP, VIMEO_REGEXP} from '../../utilites/helpers/constants';

const externalVideoLink = function(url) {
  if (url){
    let youtubeMatches = YOUTUBE_REGEXP.exec(url);
    let vimeoMatches = VIMEO_REGEXP.exec(url);
    return (!youtubeMatches && !vimeoMatches) ? 'is not valid' : '';
  }
};


export default externalVideoLink;



// WEBPACK FOOTER //
// ./src/utilites/validate/externalVideoLink.js